import type { TripPlannerSurfaceActivityEntry } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityEntryTypes'
import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'

// occurredAt is the caller's timestamp, not one taken here -- see buildItemDeletedActivityEntry
// for why (same delete-request-await shape).
export function buildStopDeletedActivityEntry(
  placeName: string,
  sourcePath: 'trip_planner.itinerary.canvas.delete_stop' | 'trip_planner.drawer.delete_stop',
  occurredAt: string,
): TripPlannerSurfaceActivityEntry {
  return {
    kind: 'stop_deleted',
    label: 'Deleted itinerary stop',
    displayText: boundActivityDisplayText(`Removed "${placeName}" from the itinerary`),
    sourcePath,
    dataClassification: 'personalised_surface',
    occurredAt,
  }
}
